export default __webpack_public_path__ + "static/media/nunito-semibold.06337b2e.ttf";